import {
  NAVIGATION_TO_LANDING_PAGE,
  NAVIGATION_TO_STEP_1,
  NAVIGATION_TO_STEP_2,
} from '../../actions/page';
import {
  RECEIVE_USER_PREFERENCES,
  RECEIVE_USER_PREFERENCES_ENABLED,
  RECEIVE_USER_PREFERENCES_FETCH_ERROR,
  RECEIVE_PREFERENCES_SAVE_STATE,
  RECEIVE_IS_SAVING_PREFERENCES,
  RECEIVE_USER_PREFERENCES_IS_SIGNING_UP,
  RECEIVE_USER_PREFERENCES_EMAIL_ADDRESS,
  RECEIVE_USER_PREFERENCES_SKIP_EMAIL_INPUT,
  RECEIVE_USER_PREFERENCES_APPLIED,
  RECEIVE_USER_PREFERENCES_FORM_ANALYTICS_SENT,
} from '../../actions/userPreferences';

export const initialState = {
  enabled: false,
  applied: false,
  preferences: undefined,
  profile: undefined,
  saveState: undefined,
  isSaving: false,
  fetchError: false,
  isSigningUp: false,
  emailAddress: undefined,
  skipEmailInput: false,
  displayEmailInput: false,
  validForm: false,
  formAnalyticsSent: false,
};

export default (
  state = initialState,
  {
    type,
    data: {
      enabled,
      preferences,
      profile,
      emailAddress,
      validForm,
      skipEmailInput,
      displayEmailInput,
      applied,
      saveState,
      isSigningUp,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_USER_PREFERENCES:
      return {
        ...state,
        enabled: true,
        preferences,
        profile,
        saveState: undefined,
        fetchError: false,
      };

    case RECEIVE_USER_PREFERENCES_ENABLED:
      return {
        ...state,
        enabled,
      };

    case RECEIVE_IS_SAVING_PREFERENCES:
      return {
        ...state,
        isSaving: true,
      };

    case RECEIVE_PREFERENCES_SAVE_STATE:
      return {
        ...state,
        saveState,
        isSaving: false,
      };

    case RECEIVE_USER_PREFERENCES_FETCH_ERROR:
      return {
        ...state,
        fetchError: true,
      };

    case RECEIVE_USER_PREFERENCES_IS_SIGNING_UP:
      return {
        ...state,
        isSigningUp,
        displayEmailInput,
        emailAddress: initialState.emailAddress,
        validForm: initialState.validForm,
        saveState: initialState.saveState,
      };

    case RECEIVE_USER_PREFERENCES_EMAIL_ADDRESS:
      return {
        ...state,
        emailAddress,
        validForm,
        saveState: initialState.saveState,
      };

    case RECEIVE_USER_PREFERENCES_SKIP_EMAIL_INPUT:
      return {
        ...state,
        skipEmailInput,
      };

    case RECEIVE_USER_PREFERENCES_APPLIED:
      return {
        ...state,
        applied,
      };

    case RECEIVE_USER_PREFERENCES_FORM_ANALYTICS_SENT:
      return { ...state, formAnalyticsSent: true };

    case NAVIGATION_TO_STEP_1:
    case NAVIGATION_TO_STEP_2:
      return {
        ...state,
        isSigningUp: initialState.isSigningUp,
        emailAddress: initialState.emailAddress,
        validForm: initialState.validForm,
        displayEmailInput: initialState.displayEmailInput,
      };

    case NAVIGATION_TO_LANDING_PAGE:
      return {
        ...initialState,
        enabled: state.enabled,
      };

    default:
      return state;
  }
};
